module.exports = __webpack_public_path__ + "static/img/service details_QR code.fb67c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fuwuxiang/service details_QR code.png
// module id = kzu6
// module chunks = 1